<template>
  <div class="pie-chart">
    <div class="pie-chart__title"> {{ title }} </div>
    <Pie :chartData="chartData"
         :chartOptions="chartOptions"
         :chartId="chartId"
         :width="width"
         :height="height"
    />
  </div>
</template>

<script>
import { Pie } from "vue-chartjs";
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

Chart.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: "PieChart",
  components: { Pie },
  props: {
    title: String,
    dataSet: {
      type: Object,
      default() {
        return {};
      },
    },
    chartId: {
      type: String,
      default: "pie-chart",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      colors: [
        "#ff5500",
        "#ffcf00",
        "#33cc33",
        "#0073e6",
        "#e60000",
        "#702963",
        "#BEBEBE",
      ],
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: {
              label: function ({ label, formattedValue }) {
                formattedValue = formattedValue.replace(',', '.')
                return `${label}: ${parseFloat(formattedValue).toFixed(2)*100}%`;
              },
            },
          },
        },
      },
    };
  },
  created() {
    this.chartData.labels = this.dataSet.labels;
    this.chartData.datasets = [
      {
        data: this.dataSet.data,
        backgroundColor: this.colors.slice(0, this.dataSet?.data?.length),
      },
    ];
  },
};
</script>

<style lang="scss" scoped>
.pie-chart {
  padding: 2rem 0;

  &__title {
    color: #868e96;
    font-size: 1.125rem;
    text-align: left;
    font-weight: 500;
    padding-left: 2rem;
  }
}
</style>
